import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//axios
import axios from 'axios'
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['ClientID'] = process.env.VUE_APP_CLIENT_ID;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + process.env.VUE_APP_API_KEY;

// Bootstrap
/* import './assets/bootstrap.min.css' */
import "./assets/admin.css";
import './assets/timeline.css'
import './assets/editor.css'
import './branding.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
//import "./assets/scripts.js";

// Sweetalert2 // 12kb + 626 KB
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'; // 41 KB
Vue.use(VueSweetalert2);

// Validate 132kb
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

// vue-loading-overlay // 12kb
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; // 503 bytes
Vue.use(Loading, { color: '#0061f2', loader: 'dots', canCancel: true, });

// GoodTable
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

// Ratings
import StarRating from 'vue-star-rating'
Vue.component('star-rating', StarRating);

// vue-beautiful-chat ...
import Chat from './chat'
Vue.use(Chat)

// filter
import './helper/filters'
// wysiwyg
//import './helper/wysiwyg.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
